module.exports = __webpack_public_path__ + "static/media/arrow.left_p.0c839619.svg";